import type { z } from 'zod';
import type {
  corporateKindEnum,
  corporateSearchMatchTypeEnum,
} from '../_models/government-search';

export type FetchGovernmentParams = {
  searchString: string;
  corporateKinds: z.infer<typeof corporateKindEnum>[] | null;
  prefectureCode: string | null;
  historySearch: boolean | null;
  excludeClosedCorporation: boolean | null;
  matchType: z.infer<typeof corporateSearchMatchTypeEnum>;
};

export type FetchGovernmentNumberParams = {
  corporateNumber: string;
};

export const governmentSearchQueryKeyMap = {
  government: (params?: FetchGovernmentParams) =>
    ['government', params].filter((item) => item !== undefined),
  governmentNumber: (params?: FetchGovernmentNumberParams) =>
    ['governmentNumber', params].filter((item) => item !== undefined),
};
